import ActionKeys from '../actions/ActionKeys';

const initialState = {
    detail: null,
};

const initialStateCopy = {
    isCopy: false,
};

const initStateAddPackage = {
    openAddPackage: null
}

const initExchangeCode = {
    code: null
}

export const importGoodsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionKeys.IMPORT_GOODS.GET_DETAIL:
            return {
                ...state,
                detail: action.data,
            };
        default:
            return state;
    }
};


export const isCoppyReducer = (state = initialStateCopy, action) => {
    switch (action.type) {
        case ActionKeys.IMPORT_GOODS.IS_COPY:
            return {
                ...state,
                isCopy: action.data,
            };
        default:
            return state;
    }
};


export const packagesReducer = (state = initStateAddPackage, action) => {
    switch (action.type) {
        case ActionKeys.IMPORT_GOODS.OPEN_ADD_PACKAGE:
            return {
                ...state,
                openAddPackage: action.payload.openAddPackage
            };
        default:
            return state;
    }
}

export const exchangeCodeReducer = (state = initExchangeCode, action) => {
    switch (action.type) {
        case ActionKeys.IMPORT_GOODS.GET_EXCHANGE_CODE:
            return {
                ...state,
                code: action.payload
            };
        default:
            return state;
    }
}